export default {
  infoToolTipText: '<p><strong>Response format</strong><br><ul><li>4 to 25 characters</li><li>made up of numbers and/or letters</li><li>contains no accents</li><li>ne contient aucun caractére spécial</li></ul></p>',
  questions: {
    label: 'Question',
  },
  answers: {
    label: 'Answer',
    lengthError: 'The response must contain a minimum of 4 and a maximum of 25 characters.',
    formatError: 'The answer must be without accents or special characters.',
    lengthAndFormatError: 'The response must be 4 to 25 characters long, with no accents or special characters.',
    unicityError: 'Each answer can only be used once.',
  },
};
